export * from './projekt-kopiert.interface';
